import { render } from "./NewEnailVerify.vue?vue&type=template&id=3be52027"
import script from "./NewEnailVerify.vue?vue&type=script&lang=js"
export * from "./NewEnailVerify.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__